import request from '../utils/request';
import type { API } from '@/types';

export const querySettingInfo = async (): Promise<API.Setting> => {
  return await request.get('/api/room/default', {
    params: {},
  }) as unknown as API.Setting;
};

export const queryPsdImportConfig = async (): Promise<API.PsdImportConfig> => {
  return await request.get('/api/setting/psd-import-config', {
    params: {},
  }) as unknown as API.PsdImportConfig;
};

export const protocol = async (params: { type: 'user_agreement' | 'privacy_agreement' | 'rule_agreement' }): Promise<string> => {
  return await request.get('/api/setting/protocol', {
    params,
  }) as unknown as string;
};

export const getSmsCode = async (data: { phone: string; type: 'login' }): Promise<{ id: string }> => {
  return await request.post('/api/sms/send', data) as unknown as { id: string };
};

export const loginByPhone = (data: {
  phone: string;
  sms_code: string;
  sms_id: string;
}): Promise<{ token: string }> => {
  return request.post('/api/user/login/phone', data) as unknown as Promise<{ token: string }>;
};

export const getUserInfo = (): Promise<API.UserInfo> => {
  return request.get('/api/user/info', { params: {} }) as unknown as Promise<API.UserInfo>;
};
